import React from 'react';
import './styles.scss';
import { Text } from '../../text/Text.tsx';

import IRunningman from '../../../resource/runningman.gif';
import { formatContent } from '../../../utils/contentUtils.tsx';

type PopupProps = {
  onClose: () => void;
};

function TeamsContact() {
  const email = "danghuyson@outlook.com";
  const teamsLink = `msteams:/l/chat/0/0?users=${email}`;

  return (
    <a href={teamsLink} className="teams-link">
      <Text variant="body">Meet me on Teams</Text>
    </a>
  );
}

export const AboutPopup: React.FC<PopupProps> = ({ onClose }) => {
  const updateVersion = '230426.1000';

  const showingContent = () => {
    return (
      <div>
        <div className="about-content">
          <div>
            <img
              className="about-image"
              src={IRunningman}
              alt="Running Man"
            />
            <Text style={{ fontStyle: 'italic', fontSize: 12, color: 'gray' }} variant="body">
              {'Version: ' + updateVersion}
            </Text>
          </div>
          <div className="about-info">
            <div className="about-detail">
              {formatContent('<b>Son Dang Huy</b> - 1991', 'title3')}
              <Text variant="body">{'Location: Ho Chi Minh City, Vietnam'}</Text>
            </div>
            <div className="about-detail">
              <Text variant="subHeadline" style={{ marginTop: 8, color: 'gray' }}>
                {'Contact'}
              </Text>
              <TeamsContact />
              <Text variant="body">{'Phone: 097-616-2761'}</Text>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 32 }}>
          <Text style={{ fontStyle: 'italic' }} variant="body">
            {'Hope to see you one day..'}
          </Text>
        </div>
      </div>
    );
  };
  return (
    <div className="win98-popup">
      <div className="popup-header">
        <Text variant="title3">{'About me'}</Text>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="popup-body">{showingContent()}</div>
    </div>
  );
};
